export const isOver18YearsOld = (date: Date): boolean => {
  const currentDate = new Date();
  const minDate = new Date(
    currentDate.getFullYear() - 18,
    currentDate.getMonth(),
    currentDate.getDate()
  );
  return date < minDate;
};
